module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('div', {
    staticClass: "center20",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/Red_Chair_Press_Books_black.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "frontmatter_copyright-center"
  }, [_c('a', {
    attrs: {
      "href": "http://www.redchairpress.com",
      "target": "_blank"
    }
  }, [_vm._v("www.redchairpress.com")])]), _vm._v(" "), _c('p', {
    staticClass: "frontmatter_copyright-center"
  }, [_vm._v("Free educator’s guide at "), _c('a', {
    attrs: {
      "href": "http://www.redchairpress.com/free-resources",
      "target": "_blank"
    }
  }, [_vm._v("www.redchairpress.com/free-resources")])]), _vm._v(" "), _c('p', {
    staticClass: "frontmatter_copyright"
  }), _vm._v(" "), _c('p', {
    staticClass: "frontmatter_copyright"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Publisher’s Cataloging-In-Publication Data ")])]), _vm._v(" "), _c('p', {
    staticClass: "frontmatter_copyright"
  }, [_vm._v("Names: Rivadeneira, Caryn Dahlstrand, author. | Alpaugh, Priscilla, \tillustrator.")]), _vm._v(" "), _c('p', {
    staticClass: "frontmatter_copyright"
  }, [_vm._v("Title: Spooky helps Danny tell the truth / Caryn Rivadeneira ; illustrated by \t\tPriscilla Alpaugh.")]), _vm._v(" "), _c('p', {
    staticClass: "frontmatter_copyright"
  }, [_vm._v("Description: Egremont, Massachusetts : Red Chair Press, [2020] | Series: \t\tHelper hounds ; [book 6] | Interest age level: 006-009. | Includes facts about American Staffordshire terriers. | Summary: “Danny is scared to tell the truth. After he saw someone steal some bikes, now he has to see that person in a courtroom and tell the court what he did. To help calm Danny’s fears on the big day, his parents call the Helper Hounds-and there’s no better pup for the job than Spooky. Spooky was involved in a crime herself-she lost her leg after being shot by a police officer who thought she was dangerous. The officer learned from his mistake and became a better person, and he thinks Danny can do the same for the bike thief. Will Spooky’s best calming tricks, like stretching and yoga, give Danny the courage to tell the truth in court-and to help change the thief’s life for the better?”-- Provided by publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "frontmatter_copyright"
  }, [_vm._v("Identifiers: ISBN 9781634409179 (hc) | ISBN 9781634409209 (sc) | ISBN \t\t9781634409230 (ebook)")]), _vm._v(" "), _c('p', {
    staticClass: "frontmatter_copyright"
  }, [_vm._v("Subjects: LCSH: American Staffordshire terrier--Juvenile fiction. | Child \t\twitnesses--Juvenile fiction. | Honesty--Juvenile fiction. | Anxiety--Juvenile fiction. | CYAC: Dogs--Fiction. | Witnesses--Fiction. | Honesty--Fiction. | Anxiety--Fiction.")]), _vm._v(" "), _c('p', {
    staticClass: "frontmatter_copyright"
  }, [_vm._v("Classification: LCC PZ7.1.R57627 Sp 2021 (print) | LCC PZ7.1.R57627 (ebook) \t\t| DDC [E]--dc23")]), _vm._v(" "), _c('p', {
    staticClass: "frontmatter_copyright"
  }, [_vm._v("Library of Congress Control Number: 2020937700")]), _vm._v(" "), _c('p', {
    staticClass: "frontmatter_copyright"
  }, [_vm._v("Text Copyright © Caryn Rivadeneira ")]), _vm._v(" "), _c('p', {
    staticClass: "frontmatter_copyright"
  }, [_vm._v("Copyright © 2021 Red Chair Press LLC")]), _vm._v(" "), _c('p', {
    staticClass: "frontmatter_copyright"
  }, [_vm._v("RED CHAIR PRESS, the RED CHAIR and associated logos are registered trademarks of Red Chair Press LLC. ")]), _vm._v(" "), _c('p', {
    staticClass: "frontmatter_copyright"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced, stored in an information or retrieval system, or transmitted in any form by any means, electronic, mechanical including photocopying, recording, or otherwise without the prior written permission from the Publisher. For permissions, contact info@redchairpress.com")]), _vm._v(" "), _c('p', {
    staticClass: "frontmatter_copyright"
  }, [_vm._v("Photos: iStock")]), _vm._v(" "), _c('p', {
    staticClass: "frontmatter_copyright"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "frontmatter_copyright"
  }, [_vm._v("0920  1P  CGS21")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-124c7f7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HelperHounds_Bk6_Spooky-2.vue
// module id = 63
// module chunks = 0